import { useState, useEffect, useMemo, useRef } from 'react';

// src/module/react/hooks/index.ts
function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(
    () => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
      return () => {
        clearTimeout(handler);
      };
    },
    [value, delay]
    // Only re-call effect if value or delay changes
  );
  return debouncedValue;
}
function useMount(callback) {
  useEffect(() => {
    const cleanup = callback();
    return () => {
      cleanup?.();
    };
  }, []);
}
function useUnmount(callback) {
  useEffect(() => {
    return () => {
      callback();
    };
  }, []);
}
function useAbortController() {
  const abortController = useMemo(() => new AbortController(), []);
  useUnmount(() => {
    return () => {
      abortController.abort();
    };
  });
  return abortController;
}
function useHover(delay = 250) {
  const [hovered, setHovered] = useState(false);
  const timeout = useRef();
  return {
    hovered,
    hoverProps: {
      onMouseEnter: () => {
        clearTimeout(timeout.current);
        timeout.current = setTimeout(() => {
          setHovered(true);
        }, delay);
      },
      onMouseLeave: () => {
        clearTimeout(timeout.current);
      }
    }
  };
}

export { useAbortController, useDebounce, useHover, useMount, useUnmount };
